
export const domainConstants = {
    theOpen: 'TheOpen',
    womensOpen: 'AIGWomensOpen',
};
